import {
  Button,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
} from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import { useNotify, useTranslate } from 'react-admin';
import dayjs from 'dayjs';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { BbOpenSessionEntry, bbGetOpenSessions } from '../../../services/blindBoxService';

export function SectionOpenSessions({ refreshKey }: { refreshKey: number }) {
  const t = useTranslate();
  const notify = useNotify();
  const [rows, setRows] = useState<BbOpenSessionEntry[]>([]);
  const [total, setTotal] = useState(0);
  const [userId, setUserId] = useState('');
  const [from, setFrom] = useState<dayjs.Dayjs | null>(null);
  const [to, setTo] = useState<dayjs.Dayjs | null>(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);

  const load = useCallback(() => {
    bbGetOpenSessions({
      userId: userId || undefined,
      from: from?.toISOString() || undefined,
      to: to?.toISOString() || undefined,
      limit: rowsPerPage,
      offset: page * rowsPerPage,
    })
      .then((r) => {
        setRows(r.entries || []);
        setTotal(r.total || 0);
      })
      .catch((e: any) => notify(e?.message || 'Error', { type: 'error' }));
  }, [userId, from, to, rowsPerPage, page, notify]);

  useEffect(() => {
    setPage(0);
  }, [userId, from, to]);

  useEffect(() => {
    load();
  }, [load, refreshKey]);

  return (
    <Stack spacing={2}>
      <Stack direction="row" spacing={2} alignItems="center" flexWrap="wrap">
        <TextField
          size="small"
          label="userId"
          value={userId}
          onChange={(e) => setUserId(e.target.value)}
          sx={{ minWidth: 280 }}
        />
        <DateTimePicker
          label="from"
          value={from}
          onChange={setFrom}
          ampm={false}
          format="YYYY/MM/DD HH:mm"
          slotProps={{
            field: { clearable: true },
            textField: { size: 'small', sx: { minWidth: 220 } },
          }}
        />
        <DateTimePicker
          label="to"
          value={to}
          onChange={setTo}
          ampm={false}
          format="YYYY/MM/DD HH:mm"
          slotProps={{
            field: { clearable: true },
            textField: { size: 'small', sx: { minWidth: 220 } },
          }}
        />
        <Button onClick={load}>{t('module.blindBox.refresh')}</Button>
      </Stack>

      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              {/*<TableCell>id</TableCell>*/}
              <TableCell>userId</TableCell>
              <TableCell>walletAddress</TableCell>
              {/*<TableCell>seasonId</TableCell>*/}
              <TableCell>openCount</TableCell>
              <TableCell>totalXp</TableCell>
              <TableCell>status</TableCell>
              <TableCell>createdAt</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((r) => (
              <TableRow key={r.id}>
                {/*<TableCell>{r.id}</TableCell>*/}
                <TableCell>{r.userId}</TableCell>
                <TableCell>{r.walletAddress}</TableCell>
                {/*<TableCell>{r.seasonId || '—'}</TableCell>*/}
                <TableCell>{r.openCount}</TableCell>
                <TableCell>{r.totalXp}</TableCell>
                <TableCell>{r.status}</TableCell>
                <TableCell>
                  {r.createdAt ? dayjs(r.createdAt).format('YYYY-MM-DD HH:mm:ss') : '—'}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        component="div"
        count={total}
        page={page}
        onPageChange={(_, nextPage) => setPage(nextPage)}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={(e) => {
          const next = parseInt(e.target.value, 10);
          setRowsPerPage(Number.isFinite(next) && next > 0 ? next : 50);
          setPage(0);
        }}
        rowsPerPageOptions={[20, 50, 100]}
      />
    </Stack>
  );
}

